<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      @base-dialog-mounted="listCardModels(partner.id)"
      dialogId="create-catalog-dialog"
      :form-ref.sync="catalogFormRef"
      :open.sync="openDialog"
      :loading.sync="isLoading"
      maxWidth="800"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer un catalogue</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <catalog-form
            :catalog-form.sync="catalogForm"
            :cardModels="cardModels"
            :currenciesChoice="currenciesChoice"
            :catalogTypesChoice="catalogTypesChoice"
            :modesChoice="modesChoice"
            :reversionTypesChoice="reversionTypesChoice"
            :rules="rules"
          ></catalog-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { onMounted, toRefs, computed } from "@vue/composition-api";
import { useCatalogs } from "@/composables/catalog";
import { useCardModel } from "@/composables/card-model";
import CatalogForm from "@/components/Catalog/CatalogForm";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    CatalogForm,
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    group: Object,
    partner: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { catalogData, createCatalog } = useCatalogs();
    const { cardModels, listCardModels } = useCardModel();

    /* Variables */

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(() => {
      catalogData.catalogForm.reversionType =
        catalogData.reversionTypesChoice[0].value;
      catalogData.catalogForm.currency = "EUR";
      catalogData.createCatalogDialog = true;
    });

    /* Méthodes */
    const saveItem = async function () {
      if (props.clientPortal != null) {
        await createCatalog(props.clientPortal.id);
      } else {
        await createCatalog(null, props.group.id);
      }
      openDialog.value = catalogData.createCatalogDialog;
    };

    return {
      createCatalog,
      ...toRefs(catalogData),
      cardModels,
      saveItem,
      listCardModels,
      openDialog,
    };
  },
};
</script>
